import { render } from "./SFormElementTextareaInput.vue?vue&type=template&id=be67e44e"
import script from "./SFormElementTextareaInput.vue?vue&type=script&lang=js"
export * from "./SFormElementTextareaInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__